module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-860.79806b17.png";